import { Component } from 'preact'
import axios from 'axios'
import { t } from 'libs/translationsUtils/translations'
import TopicListItem from './TopicListItem'
import Analytics from '../analytics/Analytics'

export default class TopicListView extends Component {
  constructor (props) {
    super(props)

    this.getTopicData = this.getTopicData.bind(this)
    this.showMoreHandler = this.showMoreHandler.bind(this)
  }

  componentDidMount () {
    const { query } = this.props
    const newQuery = { ...query, page: 1 }

    this.getTopicData(newQuery)
  }

  getTopicData (query) {
    const { requestUrl } = this.props
    const { topics } = this.state

    this.setState({
      isLoading: true
    })

    const topicDataCall = async () => {
      try {
        const res = await axios.get(requestUrl, {
          params: {
            query: JSON.stringify(query)
          }
        })

        const { data: newTopics } = res
        const newData = (topics || []).concat(newTopics)

        this.setState({
          topics: newData,
          page: query.page,
          isDone: newTopics.length < 10,
          isLoading: false
        })
      } catch (e) {
        console.error(e)
      }
    }

    topicDataCall()
  }

  showMoreHandler () {
    const { query } = this.props
    const { page } = this.state
    const newQuery = { ...query, page: page + 1 }

    Analytics.send('Homepage', 'Show more activity clicked')

    this.getTopicData(newQuery)
  }

  render (props, state) {
    const { isGuest, attachmentCdn, tab } = props
    const { topics, isDone, isLoading } = state
    let btnClass = 'btn--cta btn--full-width btn--load-more'
    let disabledButton = ''

    if (!topics) {
      return null
    }

    if (isLoading) {
      btnClass += ' is-loading'
      disabledButton = 'disabled'
    }

    return (
      <div>
        {topics.map(topic =>
          <TopicListItem
            tab={tab}
            topic={topic}
            isGuest={isGuest}
            attachmentCdn={attachmentCdn}
          />
        )}

        {
          !isDone ? (
            <div class='load-more-container'>
              <button class={btnClass} onClick={this.showMoreHandler} type='button' disabled={disabledButton}>
                {t('Forum', 'Show more')}
                <span class='loader' />
              </button>
            </div>
          ) : null
        }
      </div>
    )
  }
}
